import React from 'react'
import { useTheme } from '@mui/material'
import PropTypes from 'prop-types'
import { styled } from '@mui/material/styles'
import {
  Box,
  Button,
  Modal,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '../mui/Core/index'
import SubHeader from '../SubHeader/sub-header'
import Ellipse from '../genericcomponents/Ellipse/ellipse'

const CenteredContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  justifyContent: 'center',
  alignItems: 'center',
}))

function GenericInfoModal({ isOpen, handleClose, title, content, subContent, buttonText }) {
  const theme = useTheme()

  const containerStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '496px',
    bgcolor: theme.palette.common.white,
    boxShadow: 24,
    padding: '10px 20px 10px 25px',
    border: 'none !important',
    borderRadius: '12px',
  }

  const cardBodyStyle = {
    padding: '15px 0',
    color: theme.palette.common.black,
    fontFamily: 'AtlasGroteskRegular',
    fontSize: '16px',
    lineHeight: '20px',
  }
  const buttonsContainerStyle = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginBottom: '10px',
    gap: '10px',
  }
  const userListStyle = {
    padding: '10px 0',
    '& li': {
      paddingBottom: '0px',
      paddingTop: '0px',
      '& .MuiListItemIcon-root': {
        alignSelf: 'flex-start',
        minWidth: '15px',
        paddingTop: '12px',
      },
      '& .MuiListItemText-root': {
        marginTop: '5px',
        marginBottom: '10px',
      },
    },
  }

  const listTextStyle = {
    color: theme.palette.common.black,
    fontFamily: 'AtlasGroteskRegular',
    fontSize: '16px',
    lineHeight: '20px',
  }

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <CenteredContainer>
        <Box sx={containerStyle}>
          <SubHeader title={title} />
          <Typography sx={cardBodyStyle}>{content}</Typography>

          <List sx={userListStyle}>
            <ListItem disablePadding>
              <ListItemIcon>
                <Ellipse />
              </ListItemIcon>
              <ListItemText primaryTypographyProps={listTextStyle} primary={subContent} />
            </ListItem>
          </List>

          <Box sx={buttonsContainerStyle}>
            <Button variant='contained' color='secondary' onClick={handleClose}>
              {buttonText}
            </Button>
          </Box>
        </Box>
      </CenteredContainer>
    </Modal>
  )
}

GenericInfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  content: PropTypes.string,
  subContent: PropTypes.string,
  buttonText: PropTypes.string,
}

export default GenericInfoModal
